export default __webpack_public_path__ + "static/media/warning-icon.a230ac68.svg";